module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Holderbank-536534b12bb3dfd85fe982192eaa41e6.svg";